var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import CommonOnePlatFormActions from "@redux/actions/common/commonActions";
export var UPDATE_RECENT_CLIENT_SEARCH_GET = "UPDATE_RECENT_CLIENT_SEARCH_GET";
export var UPDATE_RECENT_CLIENT_SEARCH_SAVE = "UPDATE_RECENT_CLIENT_SEARCH_SAVE";
export var UPDATE_TRX_TYPE_LIST = "UPDATE_TRX_TYPE_LIST";
export var UPDATE_USER_POPUP_STATUS = "UPDATE_USER_POPUP_STATUS";
export var UPDATE_USER_POPUP_STATUS_SAVE = "UPDATE_USER_POPUP_STATUS_SAVE";
export var UPDATE_TRX_TYPE_LIST_ITEM = "UPDATE_TRX_TYPE_LIST_ITEM";
export var UPDATE_VALIDATE_CLIENT = "UPDATE_VALIDATE_CLIENT";
export var UPDATE_HOLDING_SUMMARY = "UPDATE_HOLDING_SUMMARY";
export var UPDATE_FOLIO_DETAILS = "UPDATE_FOLIO_DETAILS";
export var UPDATE_HOLDING_QTY_DETAILS = "UPDATE_HOLDING_QTY_DETAILS";
export var UPDATE_AGGREGATED_HOLDING = "UPDATE_AGGREGATED_HOLDINGS";
export var UPDATE_UCCCLIENT_SEARCH = "UPDATE_UCCCLIENT_SEARCH";
export var UPDATE_UCCCODECLIENT_SEARCH = "UPDATE_UCCCODECLIENT_SEARCH";
export var UPDATE_TOGGLE = "UPDATE_TOGGLE";
export var UPDATE_SELECTED_LEAD_ID = "UPDATE_SELECTED_LEAD_ID";
var GlobalActions = /** @class */ (function (_super) {
    __extends(GlobalActions, _super);
    function GlobalActions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalActions.prototype.uccCodeClientSearch = function (response) {
        this.dispatch({
            type: UPDATE_UCCCODECLIENT_SEARCH,
            payload: {
                uccCodeClientSearch: response,
            },
        });
    };
    GlobalActions.prototype.toggleLeadSelection = function (res) {
        this.dispatch({
            type: UPDATE_TOGGLE,
            payload: {
                toggleLeadSelection: res,
            },
        });
    };
    GlobalActions.prototype.selectLeadId = function (res) {
        this.dispatch({
            type: UPDATE_SELECTED_LEAD_ID,
            payload: {
                selectLeadId: res,
            },
        });
    };
    GlobalActions.prototype.updateTrxTypeListItem = function (response) {
        this.dispatch({
            type: UPDATE_TRX_TYPE_LIST_ITEM,
            payload: {
                activeTypeList: response,
            },
        });
    };
    GlobalActions.prototype.recentClientSearchGet = function (response) {
        this.dispatch({
            type: UPDATE_RECENT_CLIENT_SEARCH_GET,
            payload: {
                orderDetails: response,
            },
        });
    };
    GlobalActions.prototype.recentClientSearchSave = function (response) {
        this.dispatch({
            type: UPDATE_RECENT_CLIENT_SEARCH_SAVE,
            payload: {
                recentClientSave: response,
            },
        });
    };
    GlobalActions.prototype.trxTypeList = function (response) {
        this.dispatch({
            type: UPDATE_TRX_TYPE_LIST,
            payload: {
                trxTypeList: response,
            },
        });
    };
    GlobalActions.prototype.userPopupStatus = function (response) {
        this.dispatch({
            type: UPDATE_USER_POPUP_STATUS,
            payload: {
                orderDetails: response,
            },
        });
    };
    GlobalActions.prototype.userPopupStatusSave = function (response) {
        this.dispatch({
            type: UPDATE_USER_POPUP_STATUS_SAVE,
            payload: {
                orderDetails: response,
            },
        });
    };
    GlobalActions.prototype.validateClient = function (response) {
        this.dispatch({
            type: UPDATE_USER_POPUP_STATUS_SAVE,
            payload: {
                validateClient: response,
            },
        });
    };
    GlobalActions.prototype.holdingSummary = function (response) {
        this.dispatch({
            type: UPDATE_HOLDING_SUMMARY,
            payload: {
                holdingSummary: response,
            },
        });
    };
    GlobalActions.prototype.folioDetails = function (response) {
        this.dispatch({
            type: UPDATE_FOLIO_DETAILS,
            payload: {
                folioDetails: response,
            },
        });
    };
    GlobalActions.prototype.holdingQtyDetails = function (response) {
        this.dispatch({
            type: UPDATE_HOLDING_QTY_DETAILS,
            payload: {
                holdingQtyDetails: response,
            },
        });
    };
    GlobalActions.prototype.aggregatedHolding = function (response) {
        this.dispatch({
            type: UPDATE_AGGREGATED_HOLDING,
            payload: {
                aggregatedHolding: response,
            },
        });
    };
    GlobalActions.prototype.uccClientSearch = function (response) {
        this.dispatch({
            type: UPDATE_UCCCLIENT_SEARCH,
            payload: {
                uccClientSearch: response,
            },
        });
    };
    return GlobalActions;
}(CommonOnePlatFormActions));
export default GlobalActions;
